import React from "react";

function Products() {
  return <h1>Products page</h1>;
}

export default Products;
